import { z } from 'zod/v4';

export const ciphMessageSchema = z.object({
  driverId: z.string(),
  message: z.string(),
});

export type CpihMessage = z.infer<typeof ciphMessageSchema>;
